module.exports = __webpack_public_path__ + "img/znrx.cdf6e742.png";